angular.module('bizmetryApp').controller('LandingCtrl', function ($scope, $window, $http, $q, $timeout, $sce, CONFIG, $mdDialog) {

  // Navbar scroll state
  $scope.isScrolled = false;
  var scrollListenerActive = true;
  var onScroll = function () {
    if (!scrollListenerActive) return;
    $scope.$apply(function () {
      $scope.isScrolled = window.scrollY > 20;
    });
  };
  angular.element($window).on('scroll', onScroll);
  $scope.$on('$destroy', function () {
    angular.element($window).off('scroll', onScroll);
  });

  // View state — the navbar stays fixed on screen at all times; everything
  // else (hero/services/resources, or an embedded page) swaps in the pane
  // below it, so the user never loses the navigation bar or browser context.
  $scope.mobileMenuOpen = false;
  $scope.platformMenuOpen = false;
  $scope.closeNavigation = function () {
    $scope.mobileMenuOpen = false;
    $scope.platformMenuOpen = false;
  };
  $scope.isPlatformSection = function () {
    return ['about', 'compare', 'features', 'architecture', 'usecases', 'screenshots'].indexOf($scope.activeTab) !== -1;
  };

  $scope.activeView = 'home';   // 'home' | 'frame'
  $scope.activeTab = 'services';
  $scope.frameUrl = null;       // $sce-trusted, bound to the iframe's ng-src
  $scope.frameRawUrl = '';      // plain string, used by the "open in new tab" escape hatch
  $scope.frameTitle = '';
  $scope.frameIsVideo = false;

  // Advance the native horizontal library; suspend while the reader interacts.
  var resourceMotionPreference = $window.matchMedia('(prefers-reduced-motion: reduce)');
  $scope.technicalResourcesPaused = resourceMotionPreference.matches;
  var resourceFrame, resourceLastTime = null, resourceDirection = 1;
  var resourceManualUntil = 0, resourceTrack = null;
  var pauseForInteraction = function () { resourceManualUntil = $window.performance.now() + 6000; };
  var animateResources = function (time) {
    var elapsed = resourceLastTime === null ? 0 : Math.min(time - resourceLastTime, 50);
    resourceLastTime = time;
    if (!resourceTrack) {
      resourceTrack = document.getElementById('technical-resources-track');
      if (resourceTrack) {
        resourceTrack.addEventListener('pointerdown', pauseForInteraction, { passive: true });
        resourceTrack.addEventListener('wheel', pauseForInteraction, { passive: true });
        resourceTrack.addEventListener('keydown', pauseForInteraction);
      }
    }
    if (resourceTrack && !$scope.technicalResourcesPaused && $scope.activeView === 'home' &&
        !document.hidden && time >= resourceManualUntil && !resourceTrack.matches(':hover') &&
        !resourceTrack.contains(document.activeElement)) {
      var bounds = resourceTrack.getBoundingClientRect();
      var maximum = resourceTrack.scrollWidth - resourceTrack.clientWidth;
      if (maximum > 0 && bounds.top < $window.innerHeight && bounds.bottom > 0) {
        resourceTrack.scrollLeft += resourceDirection * elapsed * 0.035;
        if (resourceTrack.scrollLeft >= maximum - 1) resourceDirection = -1;
        else if (resourceTrack.scrollLeft <= 1) resourceDirection = 1;
      }
    }
    resourceFrame = $window.requestAnimationFrame(animateResources);
  };
  $scope.toggleTechnicalResourcesScroll = function () {
    $scope.technicalResourcesPaused = !$scope.technicalResourcesPaused;
  };
  $scope.scrollTechnicalResources = function (direction) {
    if (!resourceTrack) return;
    pauseForInteraction();
    resourceDirection = direction;
    resourceTrack.scrollBy({ left: direction * 350, behavior: resourceMotionPreference.matches ? 'auto' : 'smooth' });
  };
  resourceFrame = $window.requestAnimationFrame(animateResources);
  $scope.$on('$destroy', function () {
    $window.cancelAnimationFrame(resourceFrame);
    if (resourceTrack) {
      resourceTrack.removeEventListener('pointerdown', pauseForInteraction);
      resourceTrack.removeEventListener('wheel', pauseForInteraction);
      resourceTrack.removeEventListener('keydown', pauseForInteraction);
    }
  });

  // Advance the independent pitches and brochures carousel; suspend while the reader interacts.
  var pitchMotionPreference = $window.matchMedia('(prefers-reduced-motion: reduce)');
  $scope.pitchesResourcesPaused = pitchMotionPreference.matches;
  var pitchFrame, pitchLastTime = null, pitchDirection = 1;
  var pitchManualUntil = 0, pitchTrack = null;
  var pauseForPitchesInteraction = function () { pitchManualUntil = $window.performance.now() + 6000; };
  var animatePitches = function (time) {
    var elapsed = pitchLastTime === null ? 0 : Math.min(time - pitchLastTime, 50);
    pitchLastTime = time;
    if (!pitchTrack) {
      pitchTrack = document.getElementById('pitches-resources-track');
      if (pitchTrack) {
        pitchTrack.addEventListener('pointerdown', pauseForPitchesInteraction, { passive: true });
        pitchTrack.addEventListener('wheel', pauseForPitchesInteraction, { passive: true });
        pitchTrack.addEventListener('keydown', pauseForPitchesInteraction);
      }
    }
    if (pitchTrack && !$scope.pitchesResourcesPaused && $scope.activeView === 'home' &&
        !document.hidden && time >= pitchManualUntil && !pitchTrack.matches(':hover') &&
        !pitchTrack.contains(document.activeElement)) {
      var bounds = pitchTrack.getBoundingClientRect();
      var maximum = pitchTrack.scrollWidth - pitchTrack.clientWidth;
      if (maximum > 0 && bounds.top < $window.innerHeight && bounds.bottom > 0) {
        pitchTrack.scrollLeft += pitchDirection * elapsed * 0.035;
        if (pitchTrack.scrollLeft >= maximum - 1) pitchDirection = -1;
        else if (pitchTrack.scrollLeft <= 1) pitchDirection = 1;
      }
    }
    pitchFrame = $window.requestAnimationFrame(animatePitches);
  };
  $scope.togglePitchesResourcesScroll = function () {
    $scope.pitchesResourcesPaused = !$scope.pitchesResourcesPaused;
  };
  $scope.scrollPitchesResources = function (direction) {
    if (!pitchTrack) return;
    pauseForPitchesInteraction();
    pitchDirection = direction;
    pitchTrack.scrollBy({ left: direction * 350, behavior: pitchMotionPreference.matches ? 'auto' : 'smooth' });
  };
  pitchFrame = $window.requestAnimationFrame(animatePitches);
  $scope.$on('$destroy', function () {
    $window.cancelAnimationFrame(pitchFrame);
    if (pitchTrack) {
      pitchTrack.removeEventListener('pointerdown', pauseForPitchesInteraction);
      pitchTrack.removeEventListener('wheel', pauseForPitchesInteraction);
      pitchTrack.removeEventListener('keydown', pauseForPitchesInteraction);
    }
  });

  // Events / Documentation / brochures render in an iframe below the navbar
  // instead of leaving the site or opening a browser tab.
  $scope.showFrame = function (url, title, tab, $event) {
    $scope.closeNavigation();
    if ($event) { $event.preventDefault(); $event.stopPropagation(); }
    $scope.frameIsVideo = false;
    $scope.frameRawUrl = url;
    $scope.frameUrl = $sce.trustAsResourceUrl(url);
    $scope.frameTitle = title;
    $scope.activeTab = tab || null;
    $scope.activeView = 'frame';
  };

  $scope.goHome = function ($event) {
    $scope.closeNavigation();
    if ($event) { $event.preventDefault(); $event.stopPropagation(); }
    $scope.activeView = 'home';
    $scope.activeTab = 'services';
  };

  // Services / Resources live on the home view itself — switch back to it
  // (in case an iframe is showing) and smooth-scroll to the section.
  $scope.goToSection = function (sectionId, $event) {
    $scope.closeNavigation();
    if ($event) { $event.preventDefault(); $event.stopPropagation(); }
    $scope.activeTab = sectionId;
    $scope.activeView = 'home';
    $timeout(function () {
      var el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  };

  // Access Platform navigates to the actual authenticated app — kept as a
  // real new tab (not an iframe): login pages routinely block framing for
  // clickjacking protection, and it's bad practice to embed auth in a frame.
  // NOTE: passing a features string like 'noopener' to window.open forces the
  // browser to render a popup window with no tab strip/toolbar. To keep a
  // real tab AND avoid reverse-tabnabbing, open with no features string and
  // null out the new tab's `opener` reference instead.
  $scope.goToLogin = function ($event) {
    if ($event) { $event.preventDefault(); $event.stopPropagation(); }
    var newTab = $window.open('https://platform.bizmetry.io/login', '_blank');
    if (newTab) { newTab.opener = null; }
  };

  $scope.goToEvents = function ($event) {
    $scope.showFrame('/events/events.html', 'Events', 'events', $event);
  };

  $scope.goToDocs = function ($event) {
    $scope.showFrame('https://docs.bizmetry.io/', 'Documentation', 'docs', $event);
  };

  $scope.goToIntroVideo = function ($event) {
    $scope.showFrame('/multimedia/videos/bizmetry-intro.mp4', 'BizMetry® Introduction', null, $event);
    $scope.frameIsVideo = true;
  };

  // The card itself opens English; its English / Español links pick the language.
  $scope.goToBusinessValueDeck = function ($event, language) {
    var isSpanish = language === 'es';
    $scope.showFrame('/multimedia/pitch/Bizmetry-Business-Value-Deck' + (isSpanish ? '-ES' : '') + '.pdf',
      'Bizmetry - Business Value Deck' + (isSpanish ? ' (Español)' : ''), 'resources', $event);
  };

  $scope.goToBusinessValueSummary = function ($event, language) {
    var isSpanish = language === 'es';
    $scope.showFrame('/multimedia/pitch/Bizmetry-Business-Value-Executive-Summary' + (isSpanish ? '-ES' : '') + '.pdf',
      'Business Value - Executive Summary' + (isSpanish ? ' (Español)' : ''), 'resources', $event);
  };

  $scope.goToBrochure = function ($event) {
    $scope.showFrame('/multimedia/brochures/bizmetry-brochure.pdf', 'Platform Brochure', null, $event);
  };

  $scope.goToOutcomeDriven = function ($event) {
    $scope.showFrame('/multimedia/brochures/BizMetry-Outcome-Driven-Business-Telemetry-v3.pdf', 'Outcome-Driven Business Telemetry', null, $event);
  };

  $scope.goToSemanticModelArticle = function ($event, language) {
    var spanish = language === 'es';
    var edition = spanish ? 'ES' : 'EN';
    var title = spanish ? 'Bizmetry: Modelado de telemetría de negocio con lenguaje semántico' : 'Bizmetry: Modeling Business Telemetry Using Semantic Language';
    $scope.showFrame('/multimedia/articles/Bizmetry-Modeling-Business-Telemetry-Semantic-Language-Complete-' + edition + '.pdf', title, 'resources', $event);
  };

  $scope.goToGovernanceArticle = function ($event) {
    $scope.showFrame('/multimedia/articles/Bizmetry-Governance-Driven-Business-Telemetry.pdf', 'Bizmetry: Beyond Traditional AI Observability.', 'resources', $event);
  };

  $scope.goToApiCollectionsArticle = function ($event) {
    $scope.showFrame('/multimedia/articles/Bizmetry-API-Collections-Order-Support.pdf', 'BizMetry API Collections: From Composable Services to Business Events', 'resources', $event);
  };

  $scope.goToBmelArticle = function ($event) {
    $scope.showFrame('/multimedia/articles/Bizmetry-Expression-Language-BMEL.pdf', 'The power of Bizmetry Expression Language (BMEL)', 'resources', $event);
  };

  $scope.goToOutcomeArticle = function ($event) {
    $scope.showFrame('/multimedia/articles/Bizmetry-Outcome-Driven-Telemetry-Article.pdf', 'Outcome-Driven Telemetry Article', null, $event);
  };

  $scope.goToGenAIWalkthrough = function ($event) {
    $scope.showFrame('/multimedia/articles/Bizmetry-GenAI-Agentic-Business-Telemetry-Walkthrough.pdf', 'BizMetry® Applied to Agentic AI:  A Real Demonstration use case', null, $event);
  };

  $scope.goToWalkthrough = function ($event) {
    $scope.showFrame('/multimedia/brochures/bizmetry-platform-walkthrough.pdf', 'Platform Walkthrough', null, $event);
  };

  $scope.goToGenAIPitch = function ($event) {
    $scope.showFrame('/multimedia/pitch/Bizmetry-GenAI-Pitch.pdf', 'GenAI Use Case', null, $event);
  };

  $scope.goToDataSensingPitch = function ($event) {
    $scope.showFrame('/multimedia/pitch/Bizmetry-DataSensing-Pitch.pdf', 'Data Sensing Pitch', null, $event);
  };

  // Introduction video — technical pitch, shown as an in-page dialog
  $scope.openVideo = function () {
    $mdDialog.show({
      controller: function ($scope, $mdDialog, $sce) {
        $scope.close = function () { $mdDialog.hide(); };
        $scope.videoUrl = $sce.trustAsResourceUrl('/multimedia/videos/bizmetry-intro.mp4');
      },
      template: `
      <md-dialog aria-label="BizMetry® Introduction Video" class="video-dialog">
        <md-toolbar style="background: linear-gradient(135deg, #7B61FF 0%, #5B3FDD 60%, #9060E8 100%);">
          <div class="md-toolbar-tools">
            <h2 style="color: white; font-weight: 600;">BizMetry® Introduction</h2>
            <span flex></span>
            <md-button class="md-icon-button" ng-click="close()">
              <md-icon style="color: white;">close</md-icon>
            </md-button>
          </div>
        </md-toolbar>

        <md-dialog-content class="video-dialog-content">
          <iframe ng-src="{{videoUrl}}" width="100%" height="80%" frameborder="0" allowfullscreen></iframe>
        </md-dialog-content>
      </md-dialog>
    `,
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      escapeToClose: true
    });
  };

  // Contact — shown as a $mdDialog so it never navigates away from the page
  $scope.openContactModal = function (ev) {
    var savedScrollY = window.scrollY;
    scrollListenerActive = false;

    $mdDialog.show({
      controller: function ($scope, $mdDialog, $http, $q, CONFIG) {
        $scope.contact = {};
        $scope.sendingContact = false;
        $scope.contactSuccess = false;
        $scope.contactError = false;

        $scope.close = function () { $mdDialog.hide(); };

        function getOrFetchToken() {
          var token = sessionStorage.getItem('temp_token');
          if (token) return $q.when(token);
          return $http.post(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-account/temp-auth')
            .then(function (r) {
              sessionStorage.setItem('temp_token', r.data.access_token);
              return r.data.access_token;
            });
        }

        $scope.sendContact = function () {
          if ($scope.sendingContact) return;
          $scope.sendingContact = true;
          $scope.contactError = false;

          var payload = {
            name: $scope.contact.name,
            email: $scope.contact.email,
            subject: 'Contact Form - BizMetry',
            message: 'Contact Message from user: ' + $scope.contact.message
          };

          getOrFetchToken()
            .then(function (token) {
              return $http.post(
                CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-account/account/contact',
                payload,
                { headers: { 'Authorization': 'Bearer ' + token } }
              );
            })
            .then(function () {
              $scope.sendingContact = false;
              $scope.contactSuccess = true;
              $timeout(function () { $mdDialog.hide(); }, 3000);
            })
            .catch(function (err) {
              console.error('Contact send error:', err);
              $scope.sendingContact = false;
              $scope.contactError = true;
            });
        };
      },
      template: `
        <md-dialog aria-label="Contact Us" class="bm-contact-dialog">

          <div style="background:linear-gradient(135deg,#7B61FF 0%,#5B3FDD 60%,#9060E8 100%);padding:30px 24px 20px;display:flex;align-items:center;gap:10px;">
            <span class="material-icons" style="color:white;font-size:22px;">mail_outline</span>
            <span style="color:white;font-weight:700;font-size:1.1rem;font-family:'Syne',sans-serif;flex:1;">Contact Us</span>
            <button ng-click="close()" style="background:none;border:none;cursor:pointer;padding:6px;display:flex;align-items:center;border-radius:8px;">
              <span class="material-icons" style="color:rgba(255,255,255,0.85);font-size:20px;">close</span>
            </button>
          </div>

          <md-dialog-content style="padding:28px 24px 24px !important;background:white;">
            <div style="position:relative;min-height:400px;">

              <div ng-show="contactSuccess"
                   style="position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:18px;background:white;z-index:10;padding:20px;text-align:center;">
                <div style="width:72px;height:72px;background:linear-gradient(135deg,rgba(74,222,128,0.15),rgba(22,163,74,0.1));border-radius:50%;display:flex;align-items:center;justify-content:center;">
                  <span class="material-icons" style="font-size:38px;color:#16a34a;">check_circle</span>
                </div>
                <div>
                  <p style="font-family:'Syne',sans-serif;font-size:1.15rem;font-weight:700;color:#2A2A42;margin-bottom:8px;">Message Sent!</p>
                  <p style="font-size:0.9rem;color:#5A5A78;line-height:1.6;">Thanks for reaching out.<br>We'll get back to you shortly.</p>
                </div>
              </div>

              <div ng-style="{'opacity': contactSuccess ? '0' : '1', 'pointer-events': contactSuccess ? 'none' : 'auto'}">

                <div ng-show="contactError" style="display:flex;align-items:center;gap:10px;padding:12px 16px;background:rgba(239,68,68,0.07);border:1px solid rgba(239,68,68,0.18);border-radius:10px;color:#dc2626;font-size:0.85rem;font-weight:600;margin-bottom:16px;">
                  <span class="material-icons" style="font-size:18px;flex-shrink:0;">error_outline</span>
                  Something went wrong. Please email us at contact@bizmetry.io
                </div>

                <a href="mailto:contact@bizmetry.io"
                   style="display:flex;align-items:center;gap:14px;background:linear-gradient(135deg,#7B61FF,#5B3FDD);border-radius:14px;padding:16px 20px;margin-bottom:20px;text-decoration:none;box-shadow:0 6px 24px rgba(123,97,255,0.35);">
                  <span class="material-icons" style="color:white;font-size:26px;flex-shrink:0;">mail</span>
                  <div style="flex:1;">
                    <div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:rgba(255,255,255,0.65);margin-bottom:3px;">Write directly to us</div>
                    <div style="font-size:0.97rem;font-weight:700;color:white;">contact@bizmetry.io</div>
                  </div>
                  <span class="material-icons" style="color:rgba(255,255,255,0.5);font-size:17px;">open_in_new</span>
                </a>

                <div style="display:flex;align-items:center;gap:12px;margin-bottom:18px;">
                  <div style="flex:1;height:1px;background:#e6e6f2;"></div>
                  <span style="font-size:10px;font-weight:700;color:#9898b8;letter-spacing:0.07em;white-space:nowrap;">OR SEND A MESSAGE</span>
                  <div style="flex:1;height:1px;background:#e6e6f2;"></div>
                </div>

                <form name="contactModalForm" novalidate>
                  <div style="margin-bottom:12px;">
                    <label style="display:block;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:#5A5A78;margin-bottom:6px;">Full Name</label>
                    <input type="text" name="name" ng-model="contact.name" required placeholder="Jane Smith"
                      style="width:100%;padding:11px 14px;border:1.5px solid #e6e6f2;border-radius:10px;font-size:0.93rem;font-family:'DM Sans',sans-serif;color:#2A2A42;background:white;outline:none;box-sizing:border-box;">
                  </div>

                  <div style="margin-bottom:12px;">
                    <label style="display:block;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:#5A5A78;margin-bottom:6px;">Email Address</label>
                    <input type="email" name="email" ng-model="contact.email" required placeholder="jane@company.com"
                      style="width:100%;padding:11px 14px;border:1.5px solid #e6e6f2;border-radius:10px;font-size:0.93rem;font-family:'DM Sans',sans-serif;color:#2A2A42;background:white;outline:none;box-sizing:border-box;">
                  </div>

                  <div style="margin-bottom:18px;">
                    <label style="display:block;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:#5A5A78;margin-bottom:6px;">Message</label>
                    <textarea name="message" ng-model="contact.message" rows="3" required placeholder="Tell us how we can help…"
                      style="width:100%;padding:11px 14px;border:1.5px solid #e6e6f2;border-radius:10px;font-size:0.93rem;font-family:'DM Sans',sans-serif;color:#2A2A42;background:white;outline:none;box-sizing:border-box;resize:none;line-height:1.6;"></textarea>
                  </div>

                  <button type="button" ng-click="sendContact()"
                    ng-disabled="contactModalForm.$invalid || sendingContact"
                    ng-style="{
                      background: (contactModalForm.$invalid || sendingContact)
                        ? 'linear-gradient(135deg,#C4B8FF,#B0A0F0)'
                        : 'linear-gradient(135deg,#7B61FF 0%,#5B3FDD 60%,#9060E8 100%)',
                      cursor: (contactModalForm.$invalid || sendingContact) ? 'not-allowed' : 'pointer'
                    }"
                    style="width:100%;padding:14px 20px;color:white;border:none;border-radius:12px;font-size:1rem;font-weight:700;font-family:'DM Sans',sans-serif;display:flex;align-items:center;justify-content:center;gap:8px;">
                    <md-progress-circular ng-if="sendingContact" md-mode="indeterminate" md-diameter="18"></md-progress-circular>
                    <span class="material-icons" ng-if="!sendingContact" style="font-size:17px;">send</span>
                    <span>{{ sendingContact ? 'Sending…' : 'Send Message' }}</span>
                  </button>
                </form>
              </div>
            </div>
          </md-dialog-content>
        </md-dialog>
      `,
      parent: angular.element(document.body),
      targetEvent: ev,
      focusOnOpen: false,
      clickOutsideToClose: true,
      escapeToClose: true
    }).finally(function () {
      var html = document.documentElement;
      html.style.scrollBehavior = 'auto';
      window.scrollTo(0, savedScrollY);
      $timeout(function () {
        html.style.scrollBehavior = '';
        scrollListenerActive = true;
      }, 100);
    });
  };

});
